<div class="logs" *ngIf="isShowLogs">
  <div class="logs__head">
    <div class="logs__info" title="Logs">Logs</div>
    <div class="logs__data" title="Data">Data</div>
  </div>
  <div class="logs__list">
    <div *ngFor="let log of logs" class="logs__row">
      <div class="logs__info">
        Log Id: {{ log._id }} <br />
        Record: {{ log.record_name }} <br />
        Record Id: {{ log.sf_bulk_invite_record_id }}
      </div>
      <div class="logs__data">
        <div *ngFor="let data of log.Logs.data" [ngClass]="{ 'c-red': data.type === 'error' }">
          {{ data.text }}
        </div>
      </div>
    </div>
  </div>
</div>
